const TOOLTIP_ALIGNMENT = {
  right: { right: true },
  center: { center: true },
  left: { left: true },
}

export { TOOLTIP_ALIGNMENT }
